import * as React from "react"
import * as styles from "./styles.module.scss"
import Button from "../../Button"
import Link from "gatsby-link"

const DoubleButton: React.FC = () => {
  return (
    <div className={styles.doubleButton}>
      <Link to="/mortgage-rates/purchase" className={styles.left}>
        <Button size="lg" type="secondary" halo={true}>
          Purchase
        </Button>
      </Link>
      <Link to="/mortgage-rates/refinance" className={styles.right}>
        <Button size="lg" type="secondary" halo={true}>
          Refinance
        </Button>
      </Link>
      <Link to="/mortgage-rates" className={styles.cta}>
        <Button size="lg" type="secondary" halo={true}>
          View rates
        </Button>
      </Link>
    </div>
  )
}

export default DoubleButton
